module.exports = __webpack_public_path__ + "img/skoda_logo_new.5abb75e5.svg";